<div class="cartPPost">
  <div class="cartPPost_selected">
    <address class="cartPPost_selected_address" *ngIf="showDetails">
      {{'cart.PPWidget.pickupPoint.text' | translate}}: {{selectedPP.name}}
      <br>{{selectedPP.street}}
      <br>{{selectedPP.postCode}} {{selectedPP.town}}
    </address>
    <button (click)="newPPPoint()" [innerHTML]="(showDetails ? 'cart.PPWidget.change.button.text' : 'cart.PPWidget.choose.button.text') | translate" class="cartPPost_selected_button"></button>
    <p class="cartPPost_error" *ngIf="error" scroll-to="cartDeliveryPayment_delivery">
      {{"cart.PPwidget.error.text" | translate}}
    </p>
  </div>
</div>
